<div *ngIf="mode === 'view'" class="field field_size_{{ size ? size : 'l' }}">
  <div class="field__name">{{ name }} &nbsp;</div>
  <div class="field__value">
    <app-link [url]="value ? 'mailto:' + value : ''" [displayText]="value"></app-link>
  </div>
</div>
